
















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ContentHistory } from '@/types/history';
import { Action, Getter } from 'vuex-class';
import { PartialContent } from '@/types/content';

@Component({})
export default class HistoryManager extends Vue {
  @Getter('history/history') history!: ContentHistory[];
  @Getter('history/isLoading') isLoading!: ContentHistory[];
  @Prop() content!: PartialContent;
  @Prop() currentCommit!: string;

  get activeCommit() {
    if (this.currentCommit === 'latest' && this.history.length > 0) {
      return this.history[0].commit;
    }
    return this.currentCommit;
  }
}
